export default __webpack_public_path__ + "static/media/empty-page-vertical.2cdfb9e6.png";